import type { FC } from 'react';

import { useScreen } from '../../hooks/use-screen/use-screen';
import type { SimpleCompanyItem } from '../../types';
import { useNwtTrackingCompanies } from '../../utils/tracking';
import { SimpleCompanyCard } from '../simple-company-card/simple-company-card';

import * as Styled from './simple-company-card-grid.styled';
import { SimpleCompanyCardGridSkeleton } from './simple-company-card.skeleton';

type SimpleCardGridProps = {
  items: SimpleCompanyItem[];
  trackingPage: string;
};

export const SimpleCompanyCardGrid: FC<SimpleCardGridProps> & {
  Skeleton: typeof SimpleCompanyCardGridSkeleton;
} = ({ items, trackingPage }) => {
  const { isSmallScreen } = useScreen();
  const trackNwtEvent = useNwtTrackingCompanies();

  return (
    <Styled.Grid data-testid="SIMPLE-COMPANY-CARD-GRID">
      {items.map((company, index) => (
        <SimpleCompanyCard
          key={`simple-company-card-${company.id}-${index}`}
          item={company}
          horizontal={isSmallScreen}
          onClick={() =>
            trackNwtEvent({
              page: trackingPage,
              eventSchema: 'basic',
              event: 'opened',
              element: 'company_card',
              itemUrn: `surn:x-xing:companies:company:${company.id}`,
            })
          }
          onWasSeen={() =>
            trackNwtEvent({
              page: trackingPage,
              eventSchema: 'basic',
              event: 'entered_viewport',
              element: 'company_card',
              position: index,
              itemUrn: `surn:x-xing:companies:company:${company.id}`,
            })
          }
        />
      ))}
    </Styled.Grid>
  );
};

SimpleCompanyCardGrid.Skeleton = SimpleCompanyCardGridSkeleton;
